<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'Home',
  data() {
    return {}
  },
  created() {},
  methods: {},
  watch: {}
}
</script>
<style lang='scss'>
</style>
